import { Component, forwardRef } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

import { DemoozHistoryService, DemoozGoogleTagManagerService, DemoozGoogleMapsService } from '@demooz/services';
import { IconsService } from '@app/services';
import { HeaderComponent } from '@app/components';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [IonApp, IonRouterOutlet, forwardRef(() => HeaderComponent)],
})
export class AppComponent {
    
    constructor(
        private demoozHistoryService: DemoozHistoryService,
        private demoozGoogleTagManagerService: DemoozGoogleTagManagerService,
        private demoozGoogleMapsService: DemoozGoogleMapsService,
        private iconsService: IconsService
    ) {
        demoozGoogleTagManagerService.init();
        demoozHistoryService.init();
        demoozGoogleMapsService.init();
        iconsService.init();
    }
}
